module.exports = __webpack_public_path__ + "static/media/5.a4f224d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/mouth/5.png
// module id = 1374
// module chunks = 0